// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"96":"2934147d","182":"fe8cb83f","261":"5de6bb63","422":"dd3275ed","483":"d7074e18","763":"4b18130e","892":"c3f0221e","946":"45c3c7cb"}[chunkId] + ".chunk.js";
};